<template>
<div class="chapter">
<div class="inner_page">
<p class="C283"><strong><a id="page_5">CONTENTS</a></strong></p><a id="page_5">
</a><p class="C288"><a id="page_5"></a><a href="#/html/06_Preface#page_7">Preface</a></p>
<p class="C288"><a href="#/html/07_The_World__key_locations_visited#page_14">The World: key locations visited</a></p>
<p class="C289"><a href="#/html/08_Before_We_Go#page_16">Before We Go</a></p>
<p class="C288"><a href="#/html/09_1__On_a_Trip_to_IKEA#page_19">1. On a Trip to IKEA</a></p>
<p class="C288"><span href="#/html/10_2__Vampire_Hunting#page_43" title="Link target outside of Sample">2. Vampire Hunting</span></p>
<p class="C288"><span href="#/html/11_3__Dragon_Slaying#page_51" title="Link target outside of Sample">3. Dragon Slaying</span></p>
<p class="C288"><span href="#/html/12_4__Through_Holy_Land#page_95" title="Link target outside of Sample">4. Through Holy Land</span></p>
<p class="C288"><span href="#/html/13_5__On_Sacred_Slopes#page_125" title="Link target outside of Sample">5. On Sacred Slopes</span></p>
<p class="C288"><span href="#/html/14_6__Across_Kingdoms#page_151" title="Link target outside of Sample">6. Across Kingdoms</span></p>
<p class="C289"><span href="#/html/15_7__To_Pitcher_Plant_Paradise#page_229" title="Link target outside of Sample">7. To Pitcher Plant Paradise</span></p>
<p class="C288"><span href="#/html/16_Acknowledgements#page_269" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="C288"><span href="#/html/17_Notes#page_271" title="Link target outside of Sample">Notes</span></p>
<p class="C288"><span href="#/html/18_Index_of_plants#page_279" title="Link target outside of Sample">Index of plants</span></p>
<p class="C288"><span href="#/html/19_Index_of_places#page_286" title="Link target outside of Sample">Index of places</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_CONTENTS.vue?55fedd6a